import { sharedColors } from "@eurodrive/ui/theme/colors"

const colors = {
  ...sharedColors,
}

export default colors
